import React from 'react';
import { NumericInput as BPNumericInput } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import objectPath from 'object-path';
import { WithErrorLabel } from '@hobs/components/FormError';
import InputLabel from '../InputLabel';
import Styles from './NumericInput.module.scss';

const NumericInput = ({
  field,
  children,
  disabled,
  noMargin = false,
  strike = false,
  setFieldValue = () => {},
  indicationMessage,
  showButtons = true,
  valueNullable = false,
  onChange = () => {},
  max = 2147483647,
  ...rest
}) => {
  const name = objectPath.get(field, 'name');

  const value = field && field.value !== null ? field.value : '';

  const handleChange = (numberValue, stringValue) => {
    onChange(numberValue);

    // In case we want to remove value, so allow to set string to ''
    if (stringValue === '') {
      setFieldValue(name, '');
      return;
    }

    if (
      valueNullable &&
      (!stringValue || stringValue === '' || isNaN(numberValue))
    ) {
      setFieldValue(name, null);
    } else if (!isNaN(stringValue)) {
      setFieldValue(name, Math.min(parseInt(stringValue, 10), max));
    } else {
      setFieldValue(name, Math.min(value, max));
    }
  };

  return (
    <div
      className={classnames(Styles['numeric-input'], {
        [Styles['no-margin']]: noMargin,
        [Styles['strike']]: strike && value
      })}
    >
      {children && (
        <InputLabel indicationMessage={indicationMessage}>
          {children}
        </InputLabel>
      )}
      <BPNumericInput
        disabled={disabled}
        onValueChange={handleChange}
        className={Styles.input}
        {...field}
        {...rest}
        value={value}
        buttonPosition={showButtons ? 'right' : 'none'}
      />
    </div>
  );
};

NumericInput.propTypes = {
  field: PropTypes.object,
  disabled: PropTypes.bool,
  noMargin: PropTypes.bool,
  strike: PropTypes.bool,
  setFieldValue: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.string
  ]),
  indicationMessage: PropTypes.object,
  value: PropTypes.number,
  max: PropTypes.number,
  onChange: PropTypes.func,
  showButtons: PropTypes.bool,
  valueNullable: PropTypes.bool
};

export default WithErrorLabel(NumericInput);
